import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import ReCaptcha from 'components/Captcha/ReCaptcha';

import {
  sendFormRequest,
  changeFieldLogin,
  changeFieldPassword,
  changeFieldVerifyCode,
  selectRequestState,
  selectFieldLogin,
  selectFieldPassword,
  selectFieldVerifyCode
} from 'mt-react-common/modules/users/common/reducers/forms/signInForm';

import ButtonDefault from '../../Common/Buttons/ButtonDefault/index';

const signInFormRM = 'usersModule.forms.signInForm';

class SignIn extends Component {
  componentWillUpdate(nextProps) {
    if (
      nextProps.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      nextProps.requestState.hasSuccessQuery
    ) {
      this.props.history.replace('/');
    }
  }

  handleChangeField = async event => {
    switch (event.target.name) {
      case 'login':
        this.props.changeFieldLogin(event.target.value);
        break;
      case 'password':
        this.props.changeFieldPassword(event.target.value);
        break;
      default:
        break;
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.props.sendFormRequest();
  };

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldLogin.errors) ? 'has-error' : ''
            }`}
          >
            <label className="control-label sr-only" htmlFor="login">
              E-mail
            </label>
            <input
              onChange={this.handleChangeField}
              type="text"
              name="login"
              className="form-control input-lg"
              id="login"
              placeholder="E-mail"
              value={this.props.selectFieldLogin.value}
            />
            {errorDesc(this.props.selectFieldLogin.errors)}
          </div>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldPassword.errors) ? 'has-error' : ''
            }`}
          >
            <label className="control-label sr-only" htmlFor="password">
              Пароль
            </label>
            <input
              onChange={this.handleChangeField}
              type="password"
              name="password"
              className="form-control input-lg"
              id="password"
              placeholder="Пароль"
              value={this.props.selectFieldPassword.value}
            />
            {errorDesc(this.props.selectFieldPassword.errors)}
          </div>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldVerifyCode.errors)
                ? 'has-error'
                : ''
            }`}
          >
            <ReCaptcha
              isCheckFailValidCounterFull
              requestStateOfForm={this.props.requestState}
              changeCaptchaValue={value =>
                this.props.changeFieldVerifyCode(value)
              }
            />
            {errorDesc(this.props.selectFieldVerifyCode.errors)}
          </div>
          <ButtonDefault
            type="submit"
            buttonTitle={'Войти'}
            showLoading={this.props.requestState.hasInProgress}
            disabled={this.props.requestState.hasInProgress}
          />
        </form>
        <p className="m-t-15 m-b-0 text-center">
          <Link to={'/account/reset-password/request'}>Забыли пароль?</Link>
        </p>
      </div>
    );
  }
}

SignIn.propTypes = {
  sendFormRequest: PropTypes.func.isRequired,
  changeFieldLogin: PropTypes.func.isRequired,
  changeFieldPassword: PropTypes.func.isRequired,
  changeFieldVerifyCode: PropTypes.func.isRequired,

  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  selectFieldLogin: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  selectFieldPassword: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  selectFieldVerifyCode: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,

  history: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, signInFormRM),
  selectFieldLogin: selectFieldLogin(state, signInFormRM),
  selectFieldPassword: selectFieldPassword(state, signInFormRM),
  selectFieldVerifyCode: selectFieldVerifyCode(state, signInFormRM)
});

const mapDispatchToProps = dispatch => ({
  sendFormRequest: () => dispatch(sendFormRequest(signInFormRM)),
  changeFieldLogin: value => dispatch(changeFieldLogin(signInFormRM, value)),
  changeFieldPassword: value =>
    dispatch(changeFieldPassword(signInFormRM, value)),
  changeFieldVerifyCode: value =>
    dispatch(changeFieldVerifyCode(signInFormRM, value))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SignIn)
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/SignIn/SignIn.js